import { Button as AntButton, Modal } from 'antd';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../../../store/rootReducer';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  campusCodes: string[];
}

const CampusDetailModal: FC<IProps> = ({
  visible, setVisible, campusCodes
}) => {
  const { t } = useTranslation();
  const { campusData } = useSelector((state: RootState) => state.campusData);
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // SY0004 = 지역코드
  const SY0004 = commonCodes.find(item => item.commonCode === 'SY0004')?.detailCode;

  const getCampusName = (campusCode: string) => {
    const campus = campusData.find(item => item.campusCode === campusCode);
    return campus?.campusKorName || campusCode;
  }

  const getCampusRegion = (campusCode: string) => {
    const campus = campusData.find(item => item.campusCode === campusCode);
    const region = SY0004?.find(item => item.detailCode === campus?.sidoCode);
    return region?.korName || campusCode;
  }

  return (
    <Modal
      title={t('homepage.topBanner.title2')}
      visible={visible}
      onCancel={() => setVisible(false)}
      footer={[
        <div className='comm-btn__area justify-content-center'>
          <AntButton
            key="cancel"
            className='btn-basic gray'
            onClick={() => setVisible(false)}
          >
            {t('common.button.close')}
          </AntButton>
        </div>
      ]}
    >
      <div className='comm-table__area'>
        <table>
          <colgroup>
            <col width="40%" />
            <col width="60%" />
          </colgroup>
          <thead>
            <tr>
              <th>{t('event.education.column9')}</th>
              <th>{t('common.menu.campus')}</th>
            </tr>
          </thead>
          <tbody>
            {campusCodes.map((campusCode: any) => (
              <tr>
                <td>{getCampusRegion(campusCode)}</td>
                <td>{getCampusName(campusCode)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Modal>
  );
}

export default CampusDetailModal;
